// Soft colour blobs behind the login card: the glass effect needs something to blur.
export const LoginBackdrop = () => (
  <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" aria-hidden>
    <div className="absolute -left-40 top-1/4 size-[480px] rounded-full bg-emerald-200/50 blur-3xl dark:bg-emerald-500/10" />
    <div className="absolute -top-32 left-1/2 size-[420px] rounded-full bg-sky-200/50 blur-3xl dark:bg-sky-500/10" />
    <div className="absolute -bottom-40 -right-32 size-[520px] rounded-full bg-indigo-200/50 blur-3xl dark:bg-indigo-500/15" />
  </div>
);

LoginBackdrop.displayName = "LoginBackdrop";
